module.exports = __webpack_public_path__ + "static/media/Overjet (sagittal fissure)4.2f9279db.png";